import React from 'react';

import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../context/ProductBuilder/machine';
import { getBaseProductType } from '../../../helpers/getBaseProductType';
import { getProductStateConfig } from '../../../helpers/getProductStateConfig';
import { getProductType } from '../../../helpers/getProductType';
import { isCurrentState } from '../../../helpers/isCurrentState';
import { getLiftPositionOptions } from '../../../helpers/liftPosition';
import { throwError } from '../../../helpers/throwError';
import { ProductBuilderMachineEvent } from '../../../types';
import { Caption } from '../../Common/Caption';
import { Heading } from '../../Common/Heading';
import { Selector, SelectorImageItem } from '../../Common/Selector';
import { SectionContent } from './SectionContent';

type OnClick = (
  liftPosition: string,
  send: (event: ProductBuilderMachineEvent) => void,
) => () => void;

const onClick: OnClick = (liftPosition, send) => () => {
  send({
    type: 'UPDATE_CUSTOM',
    custom: {
      liftPosition,
    },
  });
};

export const LiftPosition = () => {
  const [state, send] = useService(productBuilderMachine);
  const {
    custom: { tiltPosition, liftPosition, measurements },
  } = state.context;
  let liftPositionOptions = getLiftPositionOptions(state.context);
  const productType = getBaseProductType(state.context);
  const subProductType = getProductType(state.context);

  if (
    isCurrentState('liftPosition', state) &&
    liftPositionOptions.length === 0
  ) {
    throwError(state);
  }

  const isVenetianTimberOrPVC =
    subProductType !== 'Venetian Aluminium' ? true : false;

  const [width, height] = measurements
    ? (measurements as string).split('x').map(value => parseInt(value))
    : [0, 0];

  // The drive controls cannot be on the same side for Aluminium or PVC blinds under a width of 459
  if (isVenetianTimberOrPVC && width < 459) {
    liftPositionOptions = liftPositionOptions.filter(
      option => option !== tiltPosition,
    );
  }

  const venetianTimberOrPVCDisclaimer =
    isVenetianTimberOrPVC && width < 459
      ? 'For blinds under 459mm width, Lift Position and Tilt Position must be on opposite sides'
      : null;

  return (
    <SectionContent>
      <Heading>Lift position</Heading>
      <Caption>What side do you want the cord on?</Caption>
      <Selector isSlider={true}>
        {liftPositionOptions.map(option => {
          const { showIcon, Icon, description } = getProductStateConfig(
            productType,
            'liftPosition',
            option,
          );
          return (
            <SelectorImageItem
              isSelected={option === liftPosition}
              onClick={onClick(option, send)}
              key={option}
              showIcon={showIcon}
              Icon={Icon}
              title={option}
              description={description}
            />
          );
        })}
      </Selector>
      {venetianTimberOrPVCDisclaimer !== null && (
        <Caption>{venetianTimberOrPVCDisclaimer}</Caption>
      )}
    </SectionContent>
  );
};
